import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoInspectionsComponent } from './autoInspections.component';
import { QuestionsComponent } from './questions/questions.component';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { ChipsModule } from 'primeng/chips';
import { StepsModule } from 'primeng/steps';
import { AutoCompleteModule, DialogModule, InputMaskModule, InputTextareaModule, OverlayPanelModule } from 'primeng/primeng';
import { HttpModule } from '@angular/http';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SelectButtonModule} from 'primeng/selectbutton';
import { MaskDirective, } from './mask.directive';
import { DataProtectionConsentComponent } from 'src/app/shared/data-protection/data-protection-consent/data-protection-consent.component';
import { DataProtectionModalComponent } from 'src/app/shared/data-protection/data-protection-modal/data-protection-modal.component';
import { DataProtectionModule } from 'src/app/shared/data-protection/data-protection.module';
import { DeceasedCustomerModalModule } from 'src/app/shared/deceased-customer-modal/deceased-customer-modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    PaginatorModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule, 
    ChipsModule,
    StepsModule,
    DialogModule,
    OverlayPanelModule,
    HttpModule,
    InputTextModule,
    InputTextareaModule,
    RadioButtonModule,
    SelectButtonModule,
    AutoCompleteModule,
    InputMaskModule,
    DataProtectionModule,
    DeceasedCustomerModalModule
  ],
  declarations: [AutoInspectionsComponent, QuestionsComponent, MaskDirective],
  providers: [
  ]
})
export class AutoInspectionsModule { }
